import plan from './managedCompaign/plan.png';
import pay from './managedCompaign/pay.png';
import verify from './managedCompaign/Verify.png';
import analyze from './managedCompaign/Analyze.png';
import execute from './managedCompaign/Execute.png';
import optimize from './managedCompaign/Optimize.png';


const bestInClassIndex = [
    {
        image: plan,
        title: 'Plan',
        text: 'We closely review your campaigns goals, target audience, and create quests.'
    },
    {
        image: execute,
        title: 'Execute',
        text: 'Next, we conduct targeted outreach, closely vet options, and distribute quest deliverables to influencers for launch.'
    },
     {
        image: verify,
        title: 'Verify',
        text: 'After each stage in your campaign, we double-check participant deliverables, track streams, and only move forward when requirements are completed.'
    }, {
        image: optimize,
        title: 'Optimize',
        text: 'We identify top performing talent, adapt schedules accordingly, and optimize for best results.'
    }, {
        image: analyze,
        title: 'Analyze',
        text: 'We provide comprehensive reporting to measure success and share insights you can use to improve your next campaign.'
    }, {
        image: pay,
        title: 'Pay',
        text: 'Lastly, we facilitate all influencer payments within two weeks of receivng payment and address any pending needs.'
    }];

export default bestInClassIndex;
